import CONFIG from '../../config';

const actions = {
  home(context) {
    context.commit('ADD_LOG', { request: 'home' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('home'), {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'home' });
          context.commit('SAVE_APPLICATION_ID', response.data?.application?.id);
          resolve(response.data);
          context.commit('SAVE_DATA', response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'home' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  offers(context, params) {
    context.commit('ADD_LOG', { request: 'offers' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('offers'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'offers' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'offers' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  consentStatus(context, params) {
    context.commit('ADD_LOG', { request: 'consentStatus' });
    return new Promise((resolve) => {
      this.axios
        .post(CONFIG.getEndpoint('consentStatus'), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'consentStatus' });
          resolve(response.data);
        })
        .catch(() => {
          context.commit('REMOVE_LOG', { request: 'consentStatus' });
        });
    });
  },
  onboardingMarketplace(context) {
    context.commit('ADD_LOG', { request: 'onboardingMarketplace' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('onboardingMarketplace'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'onboardingMarketplace' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'onboardingMarketplace' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  supplierTransactionDetails(context, params) {
    context.commit('ADD_LOG', { request: 'supplierTransactionDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('supplierTransactionDetails'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'supplierTransactionDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'supplierTransactionDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  customerBlockedTransactions(context, params) {
    context.commit('ADD_LOG', { request: 'customerBlockedTransactions' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('customerBlockedTransactions', params.marketplaceId), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'customerBlockedTransactions' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'customerBlockedTransactions' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  customerPaymentLink(context, params) {
    context.commit('ADD_LOG', { request: 'customerPaymentLink' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('customerPaymentLink'), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'customerPaymentLink' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'customerPaymentLink' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationMerchantOnboardingLink(context, params) {
    context.commit('ADD_LOG', { request: 'applicationMerchantOnboardingLink' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('applicationMerchantOnboardingLink'), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationMerchantOnboardingLink' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationMerchantOnboardingLink' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  customerDeliveryUpdate(context, params) {
    context.commit('ADD_LOG', { request: 'customerDeliveryUpdate' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('customerDeliveryUpdate', params.transactionId, params.marketplaceId), params.patchParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'customerDeliveryUpdate' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'customerDeliveryUpdate' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  customerReferralLink(context) {
    context.commit('ADD_LOG', { request: 'customerReferralLink' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('customerReferralLink'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'customerReferralLink' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'customerReferralLink' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
};
export default actions;
